import { render, staticRenderFns } from "./scheduleClassesDay.vue?vue&type=template&id=b8a695e6&scoped=true"
import script from "./scheduleClassesDay.vue?vue&type=script&lang=js"
export * from "./scheduleClassesDay.vue?vue&type=script&lang=js"
import style0 from "./scheduleClassesDay.vue?vue&type=style&index=0&id=b8a695e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a695e6",
  null
  
)

export default component.exports